<template>
    <div class="roadmap-status">
        <div class="component-title">
            <h3 class="title">{{ title }}</h3>
            <div class="roadmap-steps-navigate">
                <div class="swiper-control">
                    <b-button
                        class="swiper-button-prev"
                        id="swiper-button-prev"
                        v-b-tooltip.hover
                        ref="prev-button"
                        variant="primary-icon-only"
                        :title="$t('common.previous')"
                        :disabled="isBeginning"
                        @focusout="hidePrevButtonTooltip($event)"
                        @click="previous">
                    </b-button>
                    <b-button
                        class="swiper-button-next"
                        id="swiper-button-next"
                        v-b-tooltip.hover
                        ref="next-button"
                        variant="primary-icon-only"
                        :title="$t('common.next')"
                        :disabled="isEnd"
                        @focusout="hideNextButtonTooltip"
                        @click="next">
                    </b-button>
                </div>
            </div>
        </div>

        <div class="roadmap-steps">
            <design-2021-apprentice-swiper-component
                :slides="steps.length"
                :breakpoints="breakpoints"
                :slides-per-view="3"
                                                     :space-between="0"
                :center-insufficient-slides="true"
                :slide-to-clicked-slide="true"
                :centered-slides="false"
                :centered-slides-bounds="true"
                :enable-navigation="true"
                ref="roadmapStatusSwiper">
                <template
                    v-for="(step, index) in steps"
                    #[getSlotName(index)]>
                    <design-2021-roadmap-step-component
                        :step-in="step"
                        :key="step.id"
                        :total="steps.length"
                        :current="index"
                        @showSteps="showSteps(step.id)">
                    </design-2021-roadmap-step-component>
                </template>
            </design-2021-apprentice-swiper-component>
        </div>

        <design-2021-roadmap-step-detail-modal-component
            :title="title"
            ref="roadmap-step-detail-modal"
            :steps-in="steps"
            :tab-index="tabIndex"
            :project-id-in="projectIdIn"
            @update-steps="updateSteps($event)"
            @selected-step="updateActiveIndex">
        </design-2021-roadmap-step-detail-modal-component>
    </div>
</template>

<script>
import { CommonBus } from '../../../../app';

export default {
    name: 'design-2021-roadmap-status-component',
    props: ['stepsIn', 'projectIdIn', 'title'],
    data() {
        return {
            steps: this.stepsIn.slice(),
            tabIndex: 1,
            breakpoints: {
                1200: {
                    slidesPerView: 7,
                    spaceBetween: 0
                },
                992: {
                    slidesPerView: 6,
                    spaceBetween: 0
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 0
                },
                576: {
                    slidesPerView: 3,
                    spaceBetween: 0
                },
                320: {
                    slidesPerView: 2,
                    spaceBetween: 0
                }
            },
            swiper: null,
        };
    },
    mounted() {
        this.swiper = this.$refs.roadmapStatusSwiper.$refs.apprenticeSwiper.swiper;
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.get('step')) {
            const stepId = urlParams.get('step');
            this.showSteps(stepId);
        }
    },

    methods: {
        getSlotName(index) {
            return `slide-${index}`;
        },

        hidePrevButtonTooltip(ev) {
            const name = 'prev-button';
            if (this.$refs[name].classList.contains('swiper-button-disabled')) {
                this.$root.$emit('bv::hide::tooltip', 'swiper-button-prev');
            }
        },

        hideNextButtonTooltip(ev) {
            const name = 'next-button';
            if (this.$refs[name].classList.contains('swiper-button-disabled')) {
                this.$root.$emit('bv::hide::tooltip', 'swiper-button-next');
            }
        },

        updateSteps(steps) {
            this.steps = steps;
        },

        updateActiveIndex(index) {
            this.swiper.slideTo(index);
        },

        showSteps(step_id) {
            const name = 'roadmap-step-detail-modal';
            this.tabIndex = this.steps.map((step) => step.id).indexOf(parseInt(step_id));
            this.$refs[name].show(this.tabIndex);
        },

        next() {
            this.swiper.slideNext();
        },

        previous() {
            this.swiper.slidePrev();
        },
    },

    computed: {
        isBeginning() {
            if (!this.swiper) {
                return false;
            }

            return this.swiper.isBeginning;
        },

        isEnd() {
            if (!this.swiper) {
                return false;
            }

            return this.swiper.isEnd;
        },
    },
};
</script>

<style scoped lang="scss">
.roadmap-steps-navigate {
    .swiper-control {
        position: relative;
    }

    .swiper-button-prev,
    .swiper-button-next {
        &:after {
            font-size: 1.125rem;
            font-weight: $font-weight-bold;
        }

        &[disabled='disabled'] {
            cursor: default;
        }
    }

    .swiper-button-prev {
        right: 30px;
        left: auto;
    }

    .swiper-button-next {
        right: -8px;
        left: auto;
    }
}

.roadmap-steps ::v-deep {
    .swiper-container {
        padding: map-get($grid-gutter-spacing, 'fifteen');

        .swiper-button-prev,
        .swiper-button-next {
            display: none;
        }
    }

    .swiper-slide {
           &:first-child:after {
               left: 50%;
               width: 49%;
           }

           &:after {
               right: 50%;
               width: 49%;
           }

                &:after {
                    position: absolute;
                    content: '';
                    display: block;
                    border-bottom: 3px dotted $border-color;
                    top: calc(50% - 16px);
               z-index: 1;
                    left: 0;
                }

           &:not(:first-child):not(:last-child):after {
                width: 99%;
        }
    }
}
</style>
